import { BeforeAfterSlider } from '@skin-seoul/shared-components';
import { HiddenGemSection } from '@skin-seoul/shared-components';
import { AmazonSection } from '@skin-seoul/shared-components';

const GGUCampaignSection = () => {
  return (
    <div className="w-full bg-white box-border max-w-full tablet:max-w-[1280px] mx-0 tablet:mx-auto">
      <BeforeAfterSlider
        content={{
          rightSection: <HiddenGemSection />,
          leftSection: <AmazonSection />,
        }}
      />
    </div>
  );
};

export default GGUCampaignSection;
